import { useMemo } from 'react';

import {
  EReportType,
  IClubLoadByDayOfWeekReportResponse,
  IOverviewReportResponse,
} from 'schemas';

import { IReportsData } from './interfaces';

export const useReportsData = (
  overviewReport: IOverviewReportResponse | undefined,
  clubLoadByDayReport: IClubLoadByDayOfWeekReportResponse | undefined
): IReportsData => {
  return useMemo(() => {
    const defaultResult: IReportsData = {
      financialData: undefined,
      bonusesData: undefined,
      goodsData: undefined,
      clientsData: undefined,
      operatingData: undefined,
      expenseData: undefined,
      clubLoadData: undefined,
    };

    if (!overviewReport?.overviewReport.data) {
      return defaultResult;
    }

    const result: IReportsData = { ...defaultResult };
    const { data } = overviewReport.overviewReport;

    data.forEach((report) => {
      switch (report.title) {
        case EReportType.FINANCE:
          result.financialData = report;
          break;
        case EReportType.BONUSES:
          result.bonusesData = report;
          break;
        case EReportType.GOODS:
          result.goodsData = report;
          break;
        case EReportType.CLIENTS:
          result.clientsData = report;
          break;
        case EReportType.OPERATION:
          result.operatingData = report;
          break;
        case EReportType.EXPENSE:
          result.expenseData = report;
          break;
      }
    });

    result.clubLoadData = clubLoadByDayReport?.clubLoadByDayOfWeekReport.data;

    return result;
  }, [overviewReport, clubLoadByDayReport]);
};
